import { baseUrl } from "../utils/baseUrl";
import jwtInterceptor from "./autorizacao/jwt-interceptor";

class ServicossSolicitacao {
    create(produto) {
        return jwtInterceptor.post(`${baseUrl}/solicitacaoProduto`, produto)
    }
    listarTodos(){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoProduto`)
    }
    editar(id, solicitacao){
        return jwtInterceptor.put(`${baseUrl}/solicitacaoProduto/${id}`, solicitacao)
    }
    deletar(id){
        return jwtInterceptor.delete(`${baseUrl}/solicitacaoProduto/${id}`)
    }
    minhasSolicitacoes(id){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoProduto/lista/${id}`)
    }
    solicitarTroca(solicitacao){
        return jwtInterceptor.post(`${baseUrl}/solicitacaoProduto`, solicitacao)
    }
    listarTodasSolicitacoes(){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoProduto`)
    }
    listarSolicitacoesPendentes(){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoProduto/pendentes`)
    }
    cancelarSolicitacao(id_solicitacao, solicitacao){
        return jwtInterceptor.put(`${baseUrl}/solicitacaoProduto/${id_solicitacao}`, solicitacao)
    }
}

export default new ServicossSolicitacao();